import { parsePhoneNumberFromString } from 'libphonenumber-js';

interface PhoneData {
  countryCode: string;
  number: string;
}

export function formatInternationalNumber(data: PhoneData): string {
  const fullNumber = `${data.countryCode}${data.number}`;
  try {
    const parsed = parsePhoneNumberFromString(fullNumber);

    if (parsed) {
      return parsed.formatInternational();
    }
  } catch (error) {
    console.warn('전화번호 변환 실패:', data, error);
  }

  return fullNumber;
}
